import styled from 'styled-components'

export const Divider = styled.div`
    margin-bottom: 20px;
    margin-top: 1.5em;
    border-bottom: 1px  dashed #ccc;
    padding:5px;
`
